import { makeStyles } from '@material-ui/core'
import React, { CSSProperties, forwardRef, ReactNode } from 'react'

export interface Props {
    active?: {
        fill: string
        background: string
    }
    cursor?: CSSProperties['cursor']
    size?: string
    panleft?: string
    style?: CSSStyleSheet
    testId?: string
    children: ReactNode
}

const useStyles = makeStyles(() => ({
    action: {
        backgroundColor: 'rgba(0,0,0,0)',
        outline: 'none',
        border: 'none',
        '&.hover': {
            cursor: 'grab',
            backgroundColor: 'rgba(0,0,0,.1)',
        },
        padding: 0,
    },
}))

const Action = forwardRef<HTMLButtonElement, Props>(
    ({ active, cursor, children, style, testId, ...props }, ref) => {
        const classes = useStyles()

        return (
            <button
                data-testid={testId ?? 'btnDnDAction'}
                ref={ref}
                {...props}
                tabIndex={0}
                className={classes.action}
            >
                {children}
            </button>
        )
    }
)

export default Action
